import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  FormControlLabel,
  FormHelperText,
  Stack,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { FormikProps } from "formik";
import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2
import { TypeUser } from "src/interface/enum/TypeUser";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "src/utilities";
import { useAuth } from "src/context/auth";
import { IAppUser } from "src/interface/IUser";
import { ListOfStatusGlobal } from "src/interface/enum/StatusGlobal";
import {
  FollowUpType,
  ListOfFollowUpType,
} from "src/interface/enum/FollowUpType";
import { DatePicker } from "@mui/x-date-pickers";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";

// ساخت schema برای اعتبارسنجی با yup
interface FollowupScheduleFormProps {
  formik: FormikProps<any>;
  isEdit: boolean;
  editors: IAutoCompleteLabelValue[];
}

const FollowupScheduleForm = ({
  formik,
  isEdit,
  editors,
}: FollowupScheduleFormProps) => {
  const { user } = useAuth();

  const { data: CustomersData } = useQuery({
    queryKey: ["CustomersData"],
    queryFn: () =>
      fetch(API_URL + "user/getByRole/" + TypeUser.CUSTOMER, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [getCustomers, setCustomers] = useState<IAppUser[]>([]);
  useEffect(() => {
    if (CustomersData) {
      setCustomers(
        CustomersData.map((item: IAppUser) => ({
          label: item.fName + " " + item.lName + " - " + item.coName,
          value: item.id,
        }))
      );
    }
  }, [CustomersData]);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: TypeUser,
    fieldName: string
  ) => {
    formik.setFieldValue(fieldName, newValue);
  };

  return (
    <>
      {(!isEdit || (isEdit && formik.values.parentRef === null)) && (
        <Grid2 container spacing={1} marginY={1}>
          <Grid2 size={4}>
            <Stack spacing={2} alignItems={"center"} direction={"row"}>
              <Typography minWidth={100}> نوع پیگیری*: </Typography>
              <ToggleButtonGroup
                size="small"
                disabled
                color="primary"
                fullWidth
                value={formik.values.isGeneral}
                exclusive
                onChange={(event: any, newValue: any) =>
                  handleChange(event, newValue, "isGeneral")
                }
                aria-label="Platform"
              >
                <ToggleButton value="true">داخلی</ToggleButton>
                <ToggleButton value="false" disabled>
                  مشتری
                </ToggleButton>
              </ToggleButtonGroup>
            </Stack>
          </Grid2>
        </Grid2>
      )}

      <Grid2 container spacing={1} marginY={1}>
        <Grid2
          size={
            !isEdit || (isEdit && formik.values.parentRef === null) ? 3 : 12
          }
        >
          {!isEdit || formik.values.agreementRef === null ? (
            <Autocomplete
              disabled={isEdit && formik.values.parentRef !== null}
              value={
                (getCustomers.length > 0 &&
                  getCustomers.find(
                    (editor: any) => editor.value === formik.values.customerRef
                  )) ||
                null
              }
              onChange={(event: any, newValue: any) => {
                formik.setFieldValue("customerRef", newValue?.value || null);
              }}
              options={
                getCustomers.filter((g) => g.parentRef === undefined) || []
              }
              fullWidth
              renderInput={(params) => (
                <TextField
                  error={
                    formik.touched.customerRef &&
                    Boolean(formik.errors.customerRef)
                  }
                  helperText={
                    (formik.touched.customerRef &&
                      formik.errors.customerRef) as boolean
                  }
                  {...params}
                  label="مشتری"
                  placeholder="مشتری"
                />
              )}
            />
          ) : (
            <Autocomplete
              disabled={isEdit}
              value={
                (getCustomers.length > 0 &&
                  getCustomers.find(
                    (editor: any) =>
                      editor.value === formik.values.agreement?.customerRef
                  )) ||
                null
              }
              onChange={(event: any, newValue: any) => {
                formik.setFieldValue("customerRef", newValue?.value || null);
              }}
              options={
                getCustomers.filter((g) => g.parentRef === undefined) || []
              }
              fullWidth
              renderInput={(params) => (
                <TextField
                  error={
                    formik.touched.customerRef &&
                    Boolean(formik.errors.customerRef)
                  }
                  helperText={
                    (formik.touched.customerRef &&
                      formik.errors.customerRef) as boolean
                  }
                  {...params}
                  label="مشتری"
                  placeholder="مشتری"
                />
              )}
            />
          )}
        </Grid2>
        {(!isEdit || (isEdit && formik.values.parentRef === null)) && (
          <>
            <Grid2 size={3}>
              <TextField
                {...formik.getFieldProps("title")} // استفاده از ویژگی‌های فرمیک
                label="عنوان"
                error={formik.touched.title && Boolean(formik.errors.title)}
                helperText={
                  (formik.touched.title && formik.errors.title) as boolean
                }
                variant="outlined"
                disabled={isEdit && formik.values.agreementRef !== null}
                fullWidth
              />
            </Grid2>
            <Grid2 size={3}>
              <Autocomplete
                value={
                  ListOfFollowUpType.find(
                    (l) => l.value === parseInt(formik.values.followUpType, 10)
                  ) || null
                }
                disabled={isEdit && formik.values.agreementRef !== null}
                onChange={(event: any, newValue: any) => {
                  formik.setFieldValue(
                    "followUpType",
                    newValue?.value.toString() || null
                  );
                }}
                options={ListOfFollowUpType}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    error={
                      formik.touched.followUpType &&
                      Boolean(formik.errors.followUpType)
                    }
                    helperText={
                      (formik.touched.followUpType &&
                        formik.errors.followUpType) as boolean
                    }
                    {...params}
                    label="نوع پیگیری"
                    placeholder="نوع پیگیری"
                  />
                )}
              />
            </Grid2>

            <Grid2 size={3}>
              <Autocomplete
                value={
                  ListOfStatusGlobal.find(
                    (l) =>
                      l.value === parseInt(formik.values.scheduleStatus, 10)
                  ) || null
                }
                onChange={(event: any, newValue: any) => {
                  formik.setFieldValue(
                    "scheduleStatus",
                    newValue?.value.toString() || null
                  );
                }}
                options={ListOfStatusGlobal}
                fullWidth
                disabled={isEdit && formik.values.agreementRef !== null}
                renderInput={(params) => (
                  <TextField
                    error={
                      formik.touched.scheduleStatus &&
                      Boolean(formik.errors.scheduleStatus)
                    }
                    helperText={
                      (formik.touched.scheduleStatus &&
                        formik.errors.scheduleStatus) as boolean
                    }
                    {...params}
                    label="وضعیت"
                    placeholder="وضعیت"
                  />
                )}
              />
            </Grid2>
          </>
        )}
      </Grid2>

      <Grid2 container spacing={1} marginTop={1} columns={13}>
        {(!isEdit || (isEdit && formik.values.parentRef === null)) && (
          <>
            <Grid2 size={3}>
              <DatePicker
                disabled={
                  (isEdit && formik.values.parentRef !== null) ||
                  (isEdit && formik.values.agreementRef !== null)
                }
                label="تاریخ شروع"
                onChange={(date: Date | null) =>
                  formik.setFieldValue("startedOn", date)
                }
                //@ts-ignore
                value={formik.values.startedOn || null}
              />
              <FormHelperText
                error={
                  formik.touched.startedOn && Boolean(formik.errors.startedOn)
                }
              >
                {
                  (formik.touched.startedOn &&
                    formik.errors.startedOn) as boolean
                }
              </FormHelperText>
            </Grid2>
            <Grid2 size={3}>
              <DatePicker
                disabled={
                  (isEdit && formik.values.parentRef !== null) ||
                  (isEdit && formik.values.agreementRef !== null)
                }
                label="تاریخ پایان"
                onChange={(date: Date | null) =>
                  formik.setFieldValue("endedOn", date)
                }
                //@ts-ignore
                value={formik.values.endedOn || null}
              />
              <FormHelperText
                error={formik.touched.endedOn && Boolean(formik.errors.endedOn)}
              >
                {(formik.touched.endedOn && formik.errors.endedOn) as boolean}
              </FormHelperText>
            </Grid2>

            <Grid2 size={3}>
              <TextField
                disabled={
                  (isEdit && formik.values.parentRef !== null) ||
                  (isEdit && formik.values.agreementRef !== null)
                }
                {...formik.getFieldProps("period")} // استفاده از ویژگی‌های فرمیک
                label="دوره"
                type="number"
                error={formik.touched.period && Boolean(formik.errors.period)}
                helperText={
                  (formik.touched.period && formik.errors.period) as boolean
                }
                variant="outlined"
                fullWidth
              />
            </Grid2>
          </>
        )}
        <Grid2
          size={
            !isEdit || (isEdit && formik.values.parentRef === null) ? 4 : 13
          }
        >
          <Autocomplete
            disabled={
              isEdit &&
              formik.values.agreementRef !== null &&
              formik.values.parentRef === null
            }
            value={
              editors.find(
                (editor: IAutoCompleteLabelValue) =>
                  editor.value === formik.values.creatorRef
              ) || null
            }
            onChange={(event: any, newValue: any) => {
              formik.setFieldValue("creatorRef", newValue?.value || null);
            }}
            options={editors || []}
            fullWidth
            renderInput={(params) => (
              <TextField
                error={
                  formik.touched.creatorRef && Boolean(formik.errors.creatorRef)
                }
                helperText={
                  (formik.touched.creatorRef &&
                    formik.errors.creatorRef) as boolean
                }
                {...params}
                label="کارمند مرتبط"
                placeholder="کارمند مرتبط"
              />
            )}
          />
        </Grid2>
      </Grid2>
      {(!isEdit || (isEdit && formik.values.parentRef === null)) && (
        <FormControlLabel
          control={
            <Switch
              checked={formik.values.isSMS}
              disabled={isEdit && formik.values.agreementRef !== null}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                formik.setFieldValue("isSMS", event.target.checked);
              }}
            />
          }
          label="پیامک"
        />
      )}
      <Grid2 container spacing={1} marginTop={1}>
        <Grid2 size={12}>
          {!isEdit || (isEdit && formik.values.parentRef === null) ? (
            <TextField
              {...formik.getFieldProps("desc")} // استفاده از ویژگی‌های فرمیک
              label="توضیحات"
              multiline
              rows={3}
              placeholder="توضیحات"
              error={formik.touched.desc && Boolean(formik.errors.desc)}
              helperText={
                (formik.touched.desc && formik.errors.desc) as boolean
              }
              variant="outlined"
              fullWidth
            />
          ) : (
            <TextField
              {...formik.getFieldProps("childDesc")} // استفاده از ویژگی‌های فرمیک
              label="توضیحات"
              multiline
              rows={3}
              placeholder="توضیحات"
              error={
                formik.touched.childDesc && Boolean(formik.errors.childDesc)
              }
              helperText={
                (formik.touched.childDesc && formik.errors.childDesc) as boolean
              }
              variant="outlined"
              fullWidth
            />
          )}
        </Grid2>
      </Grid2>
    </>
  );
};

export default FollowupScheduleForm;
